import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { ChoiceChip } from '../../components/ui/Choice';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { PERSONALITY_MAX, PERSONALITY_OPTIONS } from '../../data/quizOptions';
import { useCopy } from '../../contexts/LanguageContext';
import { adaptLabel } from '../../utils/gender';
import { toggleValue } from '../../types/quiz';
import type { StepProps } from '../../types/quiz';
export function StepPersonality({
  profile,
  update,
  onNext
}: StepProps) {
  const copy = useCopy();
  const reachedMax = profile.child_personality.length >= PERSONALITY_MAX;
  return <div className="flex flex-1 flex-col" data-id="element-140" data-mp="2hx4lt83bmu77">
      <Headline data-id="element-141" data-mp="2czmn0aj0pvcx">{copy.steps.personality.headline(profile.child_name)}</Headline>
      <Subtext data-id="element-142" data-mp="3tee802du40c7">
        {copy.steps.personality.subtext(PERSONALITY_MAX)}{' '}
        <span className="font-semibold text-violet-600" data-id="element-143" data-mp="3tgh1iwe74blo">
          {profile.child_personality.length}/{PERSONALITY_MAX}
        </span>
      </Subtext>

      <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-144" data-mp="1le8krgob9u1f">
        {PERSONALITY_OPTIONS.map(option => <ChoiceChip key={option.key} emoji={option.emoji} label={adaptLabel(copy.options.personality[option.key], profile.child_gender)} selected={profile.child_personality.includes(option.key)} disabled={reachedMax} onSelect={() => update({
        child_personality: toggleValue(profile.child_personality, option.key, PERSONALITY_MAX)
      })} data-id="element-145" data-mp="1pfu6lritpinr" />)}
      </div>

      <div className="mt-auto pt-10" data-id="element-146" data-mp="1gfxd9clhnvmd">
        <PrimaryButton onClick={onNext} disabled={profile.child_personality.length === 0} data-id="element-147" data-mp="1ggyyg9w7xyht">
          {copy.quiz.continue}
        </PrimaryButton>
      </div>
    </div>;
}